import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Home as HomeIcon,
  Vaccines as VaccinesIcon,
  LocalHospital as HospitalIcon,
  ChildCare as ChildCareIcon,
  PhotoCamera as PhotoCameraIcon,
  Calculate as CalculateIcon,
  Psychology as PsychologyIcon,
  Description as DescriptionIcon,
  Security as SecurityIcon
} from '@mui/icons-material';

const MobileNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: 'Главная', icon: <HomeIcon />, path: '/' },
    { text: 'Вакцинация', icon: <VaccinesIcon />, path: '/vaccination' },
    { text: 'Помощь', icon: <HospitalIcon />, path: '/emergency' },
    { text: 'Дети до года', icon: <ChildCareIcon />, path: '/children-up-to-year' },
    { text: 'Библиотека', icon: <PhotoCameraIcon />, path: '/atlas' },
    { text: 'Калькулятор', icon: <CalculateIcon />, path: '/calculator' },
    { text: 'ИИ', icon: <PsychologyIcon />, path: '/ai-assistant' },
    { text: 'Приказы', icon: <DescriptionIcon />, path: '/orders' },
    { text: 'Рекомендации', icon: <SecurityIcon />, path: '/clinical-recommendations' }
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-items">
        {menuItems.map((item, index) => (
          <button
            key={index}
            className={`mobile-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => handleNavigation(item.path)}
            aria-label={item.text}
          >
            <div className="icon">{item.icon}</div>
            <div className="label">{item.text}</div>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileNavigation;
